import React from 'react'
import LoadingAnimation from './LoadingAnimation'
import { motion } from 'framer-motion'

type Props = {
  title: string
}
const LoadingComponent = ({ title }: Props): JSX.Element => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className={
        'absolute w-full h-full flex flex-col justify-center items-center gap-4 bg-white/50 z-[30]'
      }
      transition={{ type: 'spring', stiffness: 100, damping: 10, mass: 1 }}>
      <LoadingAnimation />
      <div className={'font-Spartan font-bold text-blue-primary text-xl'}>{title}</div>
    </motion.div>
  )
}
export default LoadingComponent
